import Api from "../../utils/config/api";
import { toastr } from "react-redux-toastr";
import {
  SET_CREDITS,
  RESET_PAY_STATE,
  SET_ACTIVE_PLAN,
  SET_CREDITS_SEED,
  GET_ALL_INVOICES,
  SET_AUTO_PAY_CREDITS,
} from "../types";

// credits
export const getCreditsSeed = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/payments/credits/seed`)
      .then((res) => {
        dispatch({
          type: SET_CREDITS_SEED,
          payload: res?.data?.payload,
        });

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const addCreditsOrder = (storeId, data) => () => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/payments/credits/add/${storeId}`, data)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const  getAvailableCredits = (storeId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/payments/credits/${storeId}`)
      .then((res) => {
        dispatch({
          type: SET_CREDITS,
          payload: res?.data?.payload?.credits,
        });

        if (res?.data?.payload?.auto_pay) {
          Api.get(`/v1/payments/credits/auto-pay/status/${storeId}`)
            .then((res2) => {
              const payload = res2?.data?.payload;
              dispatch({
                type: SET_AUTO_PAY_CREDITS,
                payload: {
                  ...res?.data?.payload?.auto_pay,
                  reason: payload?.reason,
                  isShowRetry: payload?.status === "failed",
                  status: res?.data?.payload?.auto_pay_authorization?.is_active,
                  paymentMethod: res?.data?.payload?.auto_pay_authorization?.type ?? "",
                },
              });
            })
            .catch((err) => {
              err?.response?.data?.errors?.map((errObj) =>
                toastr.error(errObj.msg)
              );
              return reject(err);
            });
        }

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const getSubscriptionStatus = (storeId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/subscriptions/status/${storeId}`)
      .then((res) => {
        dispatch({
          type: SET_ACTIVE_PLAN,
          payload: res?.data?.payload?.subscription,
        });

        return resolve(res?.data?.payload?.subscription);
      })
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

export const setAutoRefillCredits = (entityId, data) => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/payments/credits/auto-pay/${entityId}`, data)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const setAutoRefillPaymentMethod = (entityId, data) => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/payments/credits/payment-method/auto-pay/${entityId}`, data)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );
        return reject(err?.response?.data?.message);
      });
  });
};

export const cancelAutoPay = (entityId) => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/payments/credits/cancel/auto-pay/${entityId}`, {})
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        err?.response?.data?.errors?.map((errObj) => toastr.error(errObj.msg));
        return reject(err);
      });
  });
};

// subscriptions
export const updateBilling = (data) => () => {
  return new Promise((resolve, reject) => {
    Api.put(`/v1/users/billing`, data)
      .then(() => {
        return resolve(true);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const createSubscription = (storeId, data) => () => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/subscriptions/${storeId}`, data)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        toastr.error(err?.response?.data?.message);
        return reject(err);
      });
  });
};

export const cancelSubscription = (storeId) => () => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/subscriptions/cancel/${storeId}`)
      .then((res) => {
        toastr.success("Plan Cancelled Successfully");
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        toastr.error(err?.response?.data?.message);
        return reject(err);
      });
  });
};

export const reSubscriptionCall = (storeId) => () => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/subscriptions/re-subscribe/${storeId}`)
      .then((res) => {
        toastr.success("Plan Resubscribed Successfully");
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        toastr.error(err?.response?.data?.message);
        return reject(err);
      });
  });
};

export const getInvoicesCall = (storeId, page) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/payments/invoices/${storeId}?page=${page || "1"}`)
      .then((res) => {
        dispatch({
          type: GET_ALL_INVOICES,
          payload: res?.data?.payload,
        });
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        toastr.error(err?.response?.data?.message);
        return reject(err);
      });
  });
};

export const getNewInvoicesCall = (invoiceId) => () => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/payments/invoices/invoice-url/${invoiceId}`)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        toastr.error(err?.response?.data?.message);
        return reject(err);
      });
  });
};

export const resetPayState = () => (dispatch) => {
  dispatch({
    type: RESET_PAY_STATE,
  });
};
